<template>
  <div>
    {{ text_body }} <span class="noty-file-name">{{ file_name }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      text_body: {
        type: String,
        required: true
      },
      file_name: {
        type: String,
        required: false,
        default: ''
      }
    }
  };
</script>
<style lang="scss">
  .noty-file-name {
    color: #57718d;
  }
</style>
